<template>
    <div class="commission">
        <div class="blueInfo" style="display: flex; align-items: center;">
            <i class="el-icon-warning" style="color: #409EFF; margin-right: 5px; font-size: 16px;"></i>
            未配置提成的线路订单不发放提成；修改提成后，未完成订单按新标准结算。
        </div>
        <div class="commission-content">
            <el-form ref="commissionForm" label-width="120px" :model="commissionForm" :rules="commissionRules">
                <el-form-item label="是否发放提成" prop="commissionConfig">
                    <el-radio-group v-model="commissionForm.commissionConfig">
                        <el-radio :label="1">发放</el-radio>
                        <el-radio :label="0">不发放</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="提成规则" prop="commissionConfigId" v-if="commissionForm.commissionConfig">
                    <el-select v-model="commissionForm.commissionConfigId" placeholder="请选择提成规则">
                        <el-option v-for="item in commissionConfigList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveCommissionConfig">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <!--  -->
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            commissionForm: {
                lineId: null,
                commissionConfigId: '',
                commissionConfig: false,
            },
            commissionRules: {
                commissionConfigId: [{ required: true, message: '请选择提成规则' }],
                commissionConfig: [{ required: true, message: '请选择是否开启提成' }],
            },
            commissionConfigList: []
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            console.log('this.config',this.config)
            this.commissionForm.lineId = this.config.lineId
            this.commissionForm.commissionConfigId = this.config.commissionConfigId
            this.commissionForm.commissionConfig = this.config.commissionConfigId ? 1 : 0
            this.commissionForm.organizationId = this.config.organizationId
            this.getCommissionConfigList()
        },
        async getCommissionConfigList() {
            let params = {
                organizationId: this.commissionForm.organizationId,
            };
            let url = "/api/v1/manage/line/commissionConfig";
            let { code, data } = await this.$axios.get(url, params);
            if (code === 1) {
                this.commissionConfigList = data;
            }
        },

        async saveCommissionConfig() {
            this.$refs.commissionForm.validate(async (valid) => {
                if (valid) {
                    let params = {
                        id: this.commissionForm.lineId,
                        commissionConfigId: this.commissionForm.commissionConfig
                            ? this.commissionForm.commissionConfigId
                            : null,
                    };
                    let url = "/api/v1/manage/line/commissionConfig/update";
                    let data = await this.$axios.post(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("已更换规则");
                        this.$emit('success')
                    }
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.commission {

    .commission-content {
        width: 550px;

        .commission-tips {
            margin-left: 8px;
            font-size: 14px;
            color: #999;
            margin-top: 10px;
        }
    }
}
</style>
